import { useRouter } from 'next/router'
import React, { useEffect } from 'react'

type LinkWithFallbackProps = {
  href?: string
  url: string
  fallbackUrl: string
  children: React.ReactNode
  className?: string
}

const LinkWithFallback = ({
  href = '#',
  url,
  fallbackUrl,
  className,
  children,
}: LinkWithFallbackProps) => {
  const router = useRouter()

  useEffect(() => {
    router.prefetch(url)
    router.prefetch(fallbackUrl)
  }, [url, fallbackUrl, router])

  const handleOnClick = async () => {
    const { ok } = await fetch(url, { method: 'HEAD' })
    router.push(ok ? url : fallbackUrl)
  }
  return (
    // eslint-disable-next-line
    <a
      className={className}
      onClick={e => {
        e.preventDefault()
        handleOnClick()
      }}
      href={href || url}
    >
      {children}
    </a>
  )
}

export default LinkWithFallback
